<template>
    <div class="layout-sidebar">
        <div class="sidebar">
            <div class="sidebar-item" @mouseenter="overShow(0)" @mouseleave="onhide(0)">
                <!-- <h4 class="user-course"><i></i>我的辅导</h4> -->
                <h4 class="user-course">我的辅导</h4>
                <ul>
                    <li><i></i><router-link :to="{name:'schedule@course'}" :class="{active: $route.name === 'schedule@course'}">我的课表</router-link></li>
                    <!-- <li><i></i><router-link :to="{name:'plan@course'}" :class="{active: $route.name === 'plan@course'}">课程规划</router-link></li> -->
                    <li><i></i><router-link :to="{name:'video@course'}" :class="{active: $route.name === 'video@course'}">视频回放</router-link></li>
                </ul>
            </div>
            <div class="sidebar-item" @mouseenter="overShow(1)" @mouseleave="onhide(1)">
                <!-- <h4 class="user-record"><i></i>消费记录</h4> -->
                <h4 class="user-record">消费记录</h4>
                <ul>

                    <li><i></i><router-link :to="{name:'purchase@record'}" :class="{active: $route.name === 'purchase@record' || $route.name === 'packageList@record' || $route.name === 'detail@package'}">购买课时</router-link></li>
                    <li><i></i><router-link :to="{name:'period@record'}" :class="{active: $route.name === 'period@record'}">我的课时</router-link></li>
                    <li><i></i><router-link :to="{name:'tuition@record'}" :class="{active: $route.name === 'tuition@record'}">我的余额</router-link></li>
                    <li><i></i><router-link :to="{name:'bean@record'}" :class="{active: $route.name === 'bean@record'}">我的豆豆</router-link></li>
                    <!-- <li><router-link :to="{name:'integral@record'}" :class="{active: $route.name === 'integral@record'}">我的积分</router-link></li> -->
                </ul>
            </div>
            <div class="sidebar-item" @mouseenter="overShow(2)" @mouseleave="onhide(2)">
                <!-- <h4 class="user-account"><i></i>账号信息</h4> -->
                <h4 class="user-account">账号信息</h4>
                <ul>
                    <li><i></i><router-link :to="{name:'basic@user'}" :class="{active: $route.name === 'basic@user'}">个人信息</router-link></li>
                    <li><i></i><router-link :to="{name:'bind@user'}" :class="{active: $route.name === 'bind@user'}">绑定手机</router-link></li>
                    <li><i></i><router-link :to="{name:'password@user'}" :class="{active: $route.name === 'password@user'}">修改密码</router-link></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from './AppAvatar.vue';
import { mapState } from 'vuex';
export default {
    components: {
        Avatar
    },
    data() {
        return {
            sidebarMap: []
        };
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile
        }),
        activeName() {
            let name = this.$route.name;
            let targetName = '';
            if (name) {
                if (name.indexOf('@resource') > -1) {
                    targetName = 'coursewareList@resource';
                }
            }
            return targetName;
        }
    },
    methods: {
        overShow(index) {
            let item = document.getElementsByClassName('sidebar-item')[index];
            item.style.background = '#fcfcfc';
        },
        onhide(index) {
            let item = document.getElementsByClassName('sidebar-item')[index];
            item.style.background = '#fff';
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.sidebar {
    position: relative;
    width: 100%;
    min-height: 100%;
    background-color: #fff;
    box-sizing: border-box;
}

.sidebar-item {
    h4 {
        position: relative;
        height: 50px;
        line-height: 50px;
        padding-left: 40px;
        font-size: 14px;
        color: #282423;

        i {
            position: absolute;
            top: 17px;
            left: 46px;
            width: 16px;
            height: 16px;
        }
    }

    a {
        display: inline-block;
        width: 60%;
        height: 50px;
        line-height: 50px;
        padding-left: 16px;
        font-size: 14px;
        color: #998a87;
        text-decoration: none;
        box-sizing: border-box;
        cursor: pointer;

        &:hover {
            color: #282423;
        }

        &.active {
            color: #f4664b;
        }
    }

    .user-record i {
        background: url(../../../assets/images/user/user-record.png) no-repeat;
        background-size: 100% auto;
    }

    .user-account i {
        background: url(../../../assets/images/user/user-info.png) no-repeat;
        background-size: 100% auto;
    }

    .user-course i {
        background: url(../../../assets/images/user/user-account.png) no-repeat;
        background-size: 100% auto;
    }
}

ul {
    i {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: url(../../../assets/images/record/nav_icon_arrow.png) no-repeat;
        background-size: 100% auto;
        margin-left: 40px;
        line-height: 50px;
    }
}

.act {
    background: red;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppSidebar.vue